export default function mapStatusNameToCode(name: string) {
  switch (name) {
    case 'Created':
      return 'CREATED';
    case 'Staged':
      return 'STAGED';
    case 'Ready of Pickup':
      return 'READY';
    case 'In Transit':
      return 'IN_TRANSIT';
    case 'Completed':
      return 'COMPLETED';
    default:
      return ''; 
  }
}
